import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getNoteByUuid, updateNote } from "../apis/noteService";

const NoteEdit = () => {
  const { token, noteUuid } = useParams<{ token: string; noteUuid: string }>();
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);


  useEffect(() => {
    // Load note data
    const loadNote = async () => {
      if (!token || !noteUuid) return;
      
      try {
        const note = await getNoteByUuid(token, noteUuid);
        setContent(note.content);
      } catch (error) {
        console.error("Error loading note:", error);
        alert("連線資料有誤");
        navigate(`/noteList/${token}`);
      } finally {
        setIsLoading(false);
      }
    };

    loadNote();
  }, [noteUuid, token, navigate]);

  const handleSave = async () => {
    if (!content.trim()) {
      alert("請輸入記事內容");
      return;
    }

    if (!token || !noteUuid) {
      alert("無效的連結網址");
      return;
    }

    setIsSubmitting(true);
    try {
      await updateNote(token, noteUuid, { content });
      navigate(`/noteList/${token}`);
    } catch (error) {
      console.error("Error updating note:", error);
      alert("更新失敗，請重試");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/noteList/${token}`);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-500">載入中...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-3 py-5">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">編輯記事</h1>
        </div>

        {/* Content Form */}
        <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="輸入記事內容..."
            className="w-full h-[500px] resize-none border-none outline-none font-sans text-gray-700 leading-relaxed"
            autoFocus
          />
        </div>

        {/* Character count */}
        <div className="mb-4 text-right text-sm text-gray-500">
          {content.length} 字
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row sm:justify-center gap-3">
          <button
            onClick={handleCancel}
            className="w-full sm:w-auto px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
          >
            取消
          </button>
          <button
            onClick={handleSave}
            disabled={isSubmitting}
            className="w-full sm:w-auto px-6 py-3 bg-[#C83862] text-white rounded-lg hover:bg-[#A02850] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? "儲存中..." : "儲存"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoteEdit;